import { ApplicantRow } from "./types";

// A Portal trustee row: the ApplicantRow the review reads, plus the rest of the wallet's user
// record (status, trusteeStatus, portfolio, …) that the Portal's tables and approvals use.
export type ApplicantRecord = ApplicantRow & Record<string, any>;

// One organization secondary wallet (a User) with the organization flattened onto `org*` fields —
// the row the Portal's Trustee / New Trustee tables are built from, and the one the applicant review
// page finds again by wallet address. Both read GET /admin/organizations, so both build it here.
export const toApplicantRow = (org: any, wallet: any): ApplicantRecord => ({
  ...wallet,
  orgName: org.name,
  orgAddress: org.address,
  orgCountry: org.country,
  orgID: org.id,
  orgWebsite: org.website,
  verified: org.verified,
  // status: "pending",
  orgProofOfAddress: org.proofOfAddress,
  orgType: org.type,
  orgPhone: org.phone,
  orgEmail: org.email,
  orgVerified: org.verified,
  recentLandName: org?.verifiedLands[0]?.name,
  recentLandImage: org?.verifiedLands[0]?.image,
  // Full verified lands array — matches the `orgLands` format UserWallet/Dashboard pass to OrgPopUp
  orgVerifiedLands: Array.isArray(org?.verifiedLands) ? org.verifiedLands : [],
});
